

<mat-toolbar>
    <span>{{itemDetails.Name}}  | Unit: {{itemDetails.Unit}}</span>
    <span class="fill-remaining-space"></span>
    <button class="btn-dialog-close" mat-stroked-button (click)="onClose()"><mat-icon>clear</mat-icon></button>
  </mat-toolbar>

  <form  [formGroup] ="addItemForm" (ngSubmit)="addButtonClick()"  class="form-horizontal">
  <mat-grid-list cols="1" rowHeight="200px">
    <mat-grid-tile>
    <div class="controles-container">  
      <input type="hidden"  readonly formControlName="id">       
    <div class="row">
    <div class="col-md-12">
        <table class="table table-clear">
          <thead>
            <tr>
              <th style="width: 20%"  scope="col" style="text-align: center">In Stock</th> 
              <th style="width: 20%"  scope="col" style="text-align: center">Req.Qty</th>    
              <th style="width: 20%"  scope="col" style="text-align: center">Toatl Qty</th>  
              <th style="width: 20%"  scope="col" style="text-align: center">UnitCost</th>
              <th style="width: 20%"  scope="col" style="text-align: center">TotalCost</th>                     
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><input type="number" style="text-align: right" readonly formControlName="qtyInStock"   class="form-control form-control-sm field-bg-color"></td>                          
              <td><input type="number"  style="text-align: right" (focusout)="calculateQty()"   formControlName="qty"    [class.is-invalid]="formErrors.qty" class="form-control form-control-sm" (blur)="logValidationErrors()"></td>                           
              <td><input type="number"  style="text-align: right" readonly formControlName="totalQty"   [class.is-invalid]="formErrors.totalQty" class="form-control form-control-sm field-bg-color" (blur)="logValidationErrors()"></td>                           
              <td><input type="number" style="text-align: right" (focusout)="calculateQty()"   formControlName="unitCost"  [class.is-invalid]="formErrors.unitCost" class="form-control form-control-sm field-bg-color" (blur)="logValidationErrors()"></td>             
              <td><input type="number" style="text-align: right"  readonly formControlName="totalCost"  [class.is-invalid]="formErrors.totalCost"   class="form-control form-control-sm field-bg-color" (blur)="logValidationErrors()"></td>                                                 
           </tr>  
          </tbody>
        </table>
    </div>
  </div>


      <div class="button-row justify-content-center mt-1">
        <button type="submit" [disabled]="!addItemForm.valid"  mat-raised-button color="primary" class="mr-2">
          <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Add to Cart
        </button>         
      </div>

      </div>
    </mat-grid-tile>
  </mat-grid-list>
  <!-- Form Values : {{ addItemForm.value | json }}  -->
</form>


         

